import { AttachedFile } from '@missionlabs/smartagent-app-components'
import FileWidget from '@missionlabs/smartagent-chat-components-lib/dist/FileWidget'
import prettyBytes from 'pretty-bytes'
import { IAttachment } from 'store/tasks/tasks.state'

interface Props {
    attachments: IAttachment[]
    isEditorRedesigned?: boolean
    onRemove: (index: number, fileName: string) => void
}

const getType = (contentType: string) => {
    const parts = contentType.split('/')
    return parts[1] ? parts[1].toUpperCase() : contentType
}

const AttachmentList = ({ attachments, isEditorRedesigned, onRemove }: Props) => {
    if (!attachments.length) return null

    return (
        <>
            {attachments.map((attachment, index) =>
                isEditorRedesigned ? (
                    <FileWidget
                        fileName={attachment.filename}
                        fileType={getType(attachment.contentType)}
                        status="cancellable"
                        shouldDownload={false}
                        timestamp=""
                        src=""
                        onCancel={() => onRemove(index, attachment.filename)}
                    />
                ) : (
                    <AttachedFile
                        key={attachment.s3Key}
                        name={attachment.filename}
                        type={getType(attachment.contentType)}
                        size={prettyBytes(attachment.size)}
                        onDelete={() => onRemove(index, attachment.filename)}
                        error={attachment.error}
                    />
                ),
            )}
        </>
    )
}

export default AttachmentList
